// client/src/screens/admin/products/haberdashery/HaberdasheryFormActions.js

import React, { memo } from "react";

const HaberdasheryFormActions = memo(function HaberdasheryFormActions({
  loading = false,
  submitDisabled = false,
  submitLabel = "Save Haberdashery Product",
  resetLabel = "Reset form",
  onReset,
}) {
  return (
    <div className="admin-form-actions admin-form-actions--sticky">
      <button
        type="submit"
        className="admin-btn admin-btn--primary"
        disabled={submitDisabled}
      >
        {loading ? "Saving..." : submitLabel}
      </button>

      <button
        type="button"
        className="admin-btn admin-btn--secondary"
        onClick={onReset}
        disabled={submitDisabled}
      >
        {resetLabel}
      </button>
    </div>
  );
});

export default HaberdasheryFormActions;
